import React from 'react';

import { ParcelDetailGeneratedLabelHistory } from '@lanterds/types';
import DetailSection from 'src/components/common/DetailSection/DetailSection';
import DataTable from 'src/components/common/DataTable/DataTable';
import { formatDate } from 'src/util/formatters';
import { Indexable } from 'src/interfaces/interfaces';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';
import { Tooltip } from '@mui/material';

interface GeneratedLabelHistoryProps {
    data: Partial<ParcelDetailGeneratedLabelHistory>[];
}

export default function GeneratedLabelHistory({ data }: GeneratedLabelHistoryProps) {
    const labels = [
        'Label Generator Format',
        'Recipient Number',
        <>
            Label Created{' '}
            <Tooltip arrow title="All times are local unless otherwise specified" className="info-tooltip">
                <InfoTwoToneIcon color="primary" />
            </Tooltip>
        </>,
        'Batch Confirmation #',
        'Label Number',
        'Comment',
    ];
    const keys = [
        'labelGeneratorFormat',
        'recipientNumber',
        'labelCreated',
        'batchConfirmationNumber',
        'labelNumber',
        'comment',
    ];

    let transformedData: Array<Indexable> = [];

    if (data && data?.length > 0) {
        transformedData = data.map((datum) => {
            return {
                labelGeneratorFormat: datum?.labelGeneratorFormat,
                recipientNumber: datum?.recipientNumber,
                labelCreated: formatDate(datum?.labelCreated),
                batchConfirmationNumber: datum?.batchConfirmationNumber,
                labelNumber: datum?.labelNumber,
                comment: datum?.comment,
            };
        });
    }

    const content =
        transformedData && transformedData?.length ? <DataTable labels={labels} keys={keys} data={transformedData} /> : <></>;

    return (
        <DetailSection id="generated-label-history" title="Generated Label History">
            {content}
        </DetailSection>
    );
}

GeneratedLabelHistory.defaultProps = {
    data: [],
};
